<template>
  <v-container fluid class="home-background fill-height justify-center">
    <v-img
      class="home-image"
      max-height="400"
      max-width="600"
      :src="images.sample"
      :lazy-src="images.sample"
    />
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      content: '',
      images: {
        sample: require('../assets/logo.png')
      }
    }
  }
}
</script>
<style scoped>
.home-text {
  color: #ffff;
  font-size: 4.5em;
  font-weight: bold;
}
.home-col-text {
  margin-top: 20%;
  display: flex;
  align-items: baseline;
}
.home-background {
  background-color: #fff;
}
</style>
